// library imports
import { useEffect, useState,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PageContent, PageHeader, PageWrapper, PageContainer } from 'components/common/layout_element/LayoutElement';
import * as Constants from "_core/configs/Constants";

// User Component imports
import { Row, Button, TextInput, Stack, Icon, Tooltip, Card, Tab, CommonModal, FlexibleTextInput, Text, HTMLRenderer} from "_core/components/common/UI";
import { setLoading, setMenuState, setErrorModal, setInitializeState } from "_core/slices/scene/SceneSlice";
import * as SceneConfig from "_core/configs/SceneConfig";
import AdminTalkSendApi from "apis/AdminTalkSendApi";
import AdminTalkSendApi2 from "apis/AdminTalkSendApi2";
import { ConvertMarkdownToHTML } from "_core/utils/common";


// styles imports
import './AdminUserRagPlayground.scss';

const AdminUserRagPlayground = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const scrollContainerRef = useRef(null);
    const textareaRef = useRef(null);
    const isSendUserMessage = useRef(false);
    const tsid = useRef("");

    const { tUser, tUserAdd, tAppearanceList } = useSelector((store) => store.transaction);
    const { isLoading, initializeState } = useSelector((store) => store.scene);

    const [tabDataList, setTabDataList] = useState([]);

    // 入力チャットメッセージ
    const [message, setMessage] = useState('');
    // チャット履歴(APIのリクエスト用)
    const [history, setHistory] = useState([]);
    // チャット履歴(表示用)
    const [viewHistory, setViewHistory] = useState([]);
    // チャット受信待ち
    const [isChatWaiting, setIsChatWaiting] = useState(false);

    const [ modalInfo , setModalInfo] = useState( {
        show: false,
        text: '',
        onClick: null,
    });


    const ExecAdminTalkSendApi = AdminTalkSendApi();
    const ExecAdminTalkSend2Api = AdminTalkSendApi2();


    useEffect(() => {
        dispatch(setMenuState({ isHeader: false, isMenu: true, isFooter: false, isFullScreen: false }));
    }, [dispatch]);

    // 初期化処理
    useEffect(() => {
        if(initializeState !== Constants.INITIALIZE_STATE.allComplete)
        {
            return
        }
        dispatch(setInitializeState(Constants.INITIALIZE_STATE.pageDataFetchComplete))
    }, [initializeState]);

    // チャット内容更新時の処理
    useEffect(() => {
        // ユーザーのメッセージ以外はスキップする
        if (!isSendUserMessage.current) {
            return;
        }
        // チャットエリアの最新メッセージにスクロール
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
        }
    }, [viewHistory]);

    // チャット送信API実行
    const ExecAdminTalkSendApiRequest = async (message) => {
        // 通信中の表示を出す
        dispatch(setLoading(true));
        setIsChatWaiting(true);

        setMessage("");
        isSendUserMessage.current = true;

        let sendHistory = history;
        // historyが空の場合、welcomeメッセージを追加
        if (!history || history.length === 0) {
            sendHistory = [
                { role: 'assistant', content: tUserAdd.welcome_msg }
            ];
            setHistory(sendHistory);
            // setViewHistory([{ role: 'assistant', context: tUserAdd.welcome_msg }]);
        }
        setViewHistory((prevViewHistory) => [...prevViewHistory, { role: 'user', context:message}]);

        const targetTAppearance = tAppearanceList.find((item) => item.id === tUserAdd.t_appearance_id);

        console.log("tUser.config :: ", JSON.stringify(tUser.config));
        // チャット送信API
        const result = 
            tUser.config.version === 1
            ? await ExecAdminTalkSendApi(message, JSON.stringify(sendHistory), tUserAdd.domain, targetTAppearance.t_voice_type_id)
            : await ExecAdminTalkSend2Api(message, JSON.stringify(sendHistory), tUserAdd.domain, targetTAppearance.t_voice_type_id, tsid.current);
        isSendUserMessage.current = false;

        if (result.error || (result.response && result.response.error_code > 0)) {
            // エラーモーダル表示
            dispatch(setErrorModal({ show: true, text: result.response.error_detail }));
        }
        else
        {
            const reply = result.response.reply;

            setHistory((prevHistory) => [
                ...prevHistory,
                { role: 'user', content:message},
                { role: 'assistant', content:reply}
            ])

            setViewHistory((prevViewHistory) => [...prevViewHistory, { role: 'assistant', context:reply}]);
            if(result.response.images != null && Array.isArray(result.response.images))
            {
                setViewHistory((prevViewHistory) => [...prevViewHistory, { role: 'images', images:result.response.images}]);
            }
            if(result.response.context != null && Array.isArray(result.response.context))
            {
                setViewHistory((prevViewHistory) => [...prevViewHistory, { role: 'sources', context:result.response.context}]);
            }
            if (result.response.tsid != null) {
                tsid.current = result.response.tsid;
            }
        }

        
        // 通信中の表示を非表示
        dispatch(setLoading(false));
        setIsChatWaiting(false);
    };

    // 改行コードを <br /> に置き換えてHTMLに変換
    const formatTextWithLineBreaks = (text) => {
        const formattedText = text.replace(/\n/g, '<br />');
        return formattedText; // ReactにHTMLとして解釈させる
    };

    const handleKeyDown = (event) => {
        if ((event.ctrlKey || event.shiftKey) && event.key === "Enter") {
            event.preventDefault(); // デフォルトの動作（改行など）を防ぐ
            if (message.length > 0)
            {
                textareaRef.current.blur();
                ExecAdminTalkSendApiRequest(message)
            }
        }
    };

    useEffect(() => {
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [message]);


    return (
    <PageContent pageId="AdminUserRagPlayground">
            <PageHeader>
                <Stack className="spacing-4px">
                    <div className="page-header-title">Playground</div>
                    <div className="page-header-detail">現在の設定で{Constants.AI_NAME}に対してテストチャットを行うことができます。</div>
                </Stack>
            </PageHeader>
            <PageWrapper>
                <PageContainer>
                    {/* ここにページ内コンテンツのコンポーネントを記述 */}
                    <div className="block-center">
                        <Card className="base-card">

                            {/* 見出し、クリアボタン */}
                            {/* <Stack className="flex-center spacing-32px align-center width-full">
                                <Row className= "list-area align-center spacing-16px width-full">
                                    <Stack className="flex-right">
                                        <Button
                                            className={"clear-button width-fit secondary-border"}
                                            onClick={() => {setViewHistory([])}}
                                        >
                                            <Row className="flex-center width-fit spacing-8px">
                                                <Icon className="label-icon" icon="trash" size={24} />
                                                <div>クリア</div>
                                            </Row>
                                        </Button>
                                    </Stack>
                                </Row>
                            </Stack> */}

                            {/* チャット表示エリア */}
                            <div ref={scrollContainerRef} className="stack chat-area spacing-32px align-center width-full">
                                {viewHistory.map((item, index) => {
                                    if(item.role === 'user')
                                    {
                                        return (
                                            <Stack key={index} className="flex-left width-full chat-user spacing-8px">
                                                <Stack className="flex-left width-full">
                                                    <Row className="flex-left width-full spacing-4px">
                                                        <Icon icon="person" size={20} className="chat-icon"/>
                                                        <div className="align-right text-size-medium text-semibold">あなた</div>
                                                    </Row>
                                                </Stack>
                                                <Stack className="flex-right width-full chat-text">
                                                    <HTMLRenderer htmlContent={ConvertMarkdownToHTML(item.context)}></HTMLRenderer>
                                                </Stack>
                                            </Stack>
                                        )
                                    }
                                    else if(item.role === 'assistant')
                                    {
                                        return (
                                            <Stack key={index} className="flex-left width-full chat-assistant spacing-8px">
                                                <Stack className="flex-left width-full">
                                                    <Row className="flex-left width-full spacing-4px">
                                                        <Icon icon="exclamation-circle" size={20} className="chat-icon"/>
                                                        <div className="text-size-medium text-semibold">{Constants.AI_NAME}</div>
                                                    </Row>
                                                </Stack>
                                                <Row className="flex-left width-full chat-text">
                                                    <HTMLRenderer htmlContent={ConvertMarkdownToHTML(item.context)}></HTMLRenderer>
                                                </Row>
                                            </Stack>
                                        )
                                    }
                                    else if(item.role === 'sources')
                                    {
                                        return (
                                            <Stack key={index} className="flex-right width-full spacing-8px">
                                                <Stack className="flex-left width-full">
                                                    <Row className="flex-left width-full spacing-4px">
                                                        <Icon icon="book" size={20} className="chat-icon"/>
                                                        <div className="text-size-medium text-semibold">参照したドキュメント</div>
                                                    </Row>
                                                </Stack>
                                                <Row className="reference-sources-list flex-left width-full">
                                                    {item.context.map((context, index2) => {
                                                        return(
                                                        <Card className="base-card card-input-area popup" key={index2}>
                                                            <Stack className="card-content flex-center no-padding width-full height-full">
                                                                <div className="title text-size-normal text-semibold padding-16px" style={{position: 'relative'}}>
                                                                    <div className="title-content-area">{context.title}</div>
                                                                    <Tooltip className="tooltip-hidden" offset={0.01}>
                                                                        文字数: {context.context.length}文字<br />
                                                                    </Tooltip>
                                                                </div>
                                                                <div className="detail text-size-small height-fit padding-16px" style={{overflow: 'auto', maxHeight: '200px'}}>
                                                                    <HTMLRenderer className="detail-content-area text-size-small width-full height-full" htmlContent={formatTextWithLineBreaks(context.context)}></HTMLRenderer>
                                                                </div>
                                                                <div style={{height:16}}></div>
                                                            </Stack>
                                                        </Card>
                                                        )
                                                    })}
                                                </Row>
                                            </Stack>
                                        )
                                    }
                                    else if (item.role === 'images' && item.images.length > 0)
                                    {
                                        return (
                                            <Stack key={index} className="flex-right width-full spacing-8px">
                                                <Row className="reference-image-list flex-left width-full">
                                                    {item.images.map((image, index3) => {
                                                        return(
                                                        <Card className="reference-image base-card card-input-area popup" key={index3}>
                                                            <Stack className="card-content flex-center no-padding width-full height-full">
                                                                <img src={image} alt="" />
                                                            </Stack>
                                                        </Card>
                                                        )
                                                    })}
                                                </Row>
                                            </Stack>
                                        )
                                    }
                                    return null
                                })}
                                {
                                    isChatWaiting &&
                                    <Row className="flex-center width-full height-fit">
                                        <Row className="chat-loading flex-center spacing-8px">
                                            <div className="loading-dot"></div>
                                            <div className="loading-dot"></div>
                                            <div className="loading-dot"></div>
                                        </Row>
                                    </Row>
                                }
                                {
                                    !viewHistory || viewHistory.length === 0 &&
                                    <Stack className="flex-center align-center width-full height-full">
                                        <Text className="text-semibold text-size-medium">チャットが送信されていません</Text>
                                        <Text className="">{Constants.AI_NAME}からの応答を確認したい内容を質問してください。</Text>
                                    </Stack>
                                }
                            </div>

                            <Button
                                className={"clear-button width-fit secondary-border"}
                                onClick={() => {
                                    setViewHistory([])
                                    setHistory([])
                                    tsid.current = ""
                                }}
                            >
                                <Row className="flex-center width-fit spacing-8px">
                                    <Icon className="label-icon" icon="trash" size={24} />
                                    <div>クリア</div>
                                </Row>
                            </Button>

                            {/* メッセージ入力 */}
                            <Row className="chat-input-area width-full ">
                                <FlexibleTextInput
                                    className="textinput"
                                    // default={message}
                                    onchange={(e) => setMessage(e)}
                                    placeholder="メッセージを入力" 
                                    isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) && isLoading ? true : false}
                                    value={message}
                                    ref={textareaRef}
                                    maxHeight={300}
                                />
                                <Button className={"send-button " +(message.length > 0 ? "primary": "primary disabled")} onClick={() => {ExecAdminTalkSendApiRequest(message)}}>
                                    <Icon icon="send" size={20} className="copy-icon"/>
                                </Button>
                            </Row>
                        </Card>
                    </div>
                </PageContainer>
                <CommonModal modalInfo={modalInfo} setModalInfo={setModalInfo}></CommonModal>
            </PageWrapper>
    </PageContent>
    );
};

export default AdminUserRagPlayground;